export function Props({ state, payload, action }) {
  switch (action) {
    case 'CONNECT':
      return { ...state, Props: { ...state.Props, isSocketConnected: true } };
    case 'DISCONNECT':
      return { ...state, Props: { ...state.Props, isSocketConnected: false } };
    case 'ITEMS_COUNT_PER_PAGE':
      localStorage.setItem('@footab/itemsCountPerPage',payload.itemsCountPerPage)
      return {...state, Props:{...state.Props,itemsCountPerPage:payload.itemsCountPerPage}};
    default:
      return { ...state };
  }
}
